import { Point } from '..';
import { PointPair } from '../math/geometry/pointPair';
export class PointPairMap {
    constructor() {
        this.m = new Map();
    }
    clear() {
        this.m.clear();
    }
    get size() {
        return this.m.size;
    }
    set(pp, v) {
        this.m.set(getKey(pp), v);
    }
    delete(pp) {
        this.m.delete(getKey(pp));
    }
    has(pp) {
        return this.m.has(getKey(pp));
    }
    getPP(p, q) {
        return this.get(new PointPair(p, q));
    }
    get(pp) {
        return this.m.get(getKey(pp));
    }
    *keys() {
        for (const sKey of this.m.keys()) {
            const pp = getPP(sKey);
            yield pp;
        }
    }
    *[Symbol.iterator]() {
        for (const [x, t] of this.m) {
            yield [getPP(x), t];
        }
    }
    *values() {
        yield* this.m.values();
    }
}
function getPP(sKey) {
    const pointString = sKey.split(' ');
    const firstS = pointString[0];
    const secondS = pointString[1];
    // Remove the parentheses and split by comma
    let parts = firstS.split(',');
    // Convert the parts to numbers
    const first = new Point(Number(parts[0]), Number(parts[1]));
    parts = secondS.split(',');
    const second = new Point(Number(parts[0]), Number(parts[1]));
    const pp = new PointPair(first, second);
    return pp;
}
function getKeyPP(first, second) {
    return [localToString(first), localToString(second)].sort().join(' ');
}
function getKey(pp) {
    return getKeyPP(pp.first, pp.second);
}
function localToString(p) {
    return p.x.toString() + ',' + p.y.toString();
}
//# sourceMappingURL=pointPairMap.js.map